import { Box, BoxProps, StylesProvider, useMultiStyleConfig } from '@chakra-ui/react';
import { mergeWith } from '@chakra-ui/utils';
import PropTypes from 'prop-types';
import React from 'react';

import { CardContextProvider } from './CardContext';
import DisplayNames from './enums';

type CardVariantOption = 'basic' | 'media';

export const cardVariantPropTypes: CardVariantOption[] = ['basic', 'media'];

const propTypes = {
  children: PropTypes.node.isRequired,
  isClickable: PropTypes.bool,
  variant: PropTypes.oneOf(cardVariantPropTypes),
  isDisabled: PropTypes.bool
};
const defaultProps = {
  isClickable: false,
  isDisabled: false,
  variant: 'basic'
};

export type CardProps = BoxProps & {
  'data-disabled'?: boolean;
  isDisabled?: boolean;
  isClickable?: boolean;
  variant?: string;
};

const Card = (props: CardProps & typeof defaultProps): React.ReactElement => {
  const { children, __css, isClickable, 'data-disabled': isDataDisabled, isDisabled: isDisabledProp, ...rest } = props;

  const mergedProps = {
    tabIndex: isClickable ? 0 : undefined,
    'data-disabled': isDisabledProp || isDataDisabled,
    ...rest
  };

  const themeStyles = useMultiStyleConfig('Card', props);

  return (
    <CardContextProvider isDisabled={!!isDataDisabled || !!isDisabledProp}>
      <Box __css={mergeWith(themeStyles.card, __css)} {...mergedProps}>
        <StylesProvider value={themeStyles}>{children}</StylesProvider>
      </Box>
    </CardContextProvider>
  );
};

Card.propTypes = propTypes;
Card.defaultProps = defaultProps;
Card.displayName = DisplayNames.Card;

export default Card;
